'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

var _components = require('../../../components');
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _constants = require('../../../constants');

var _PhoneVerificationFormMyAccount = require('../PhoneVerificationFormMyAccount.scss');var styles = _interopRequireWildcard(_PhoneVerificationFormMyAccount);
var _helpButton = require('../../../../static/icons/help-button.svg');var _helpButton2 = _interopRequireDefault(_helpButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helper
// Styles
var lockIndent = function lockIndent(isMobile, locale) {if (locale === 'ru') {return 30;
  }
  return isMobile ? 15 : 10;
};var

PhoneNumberSection = function (_Component) {_inherits(PhoneNumberSection, _Component);function PhoneNumberSection() {var _temp, _this, _ret;_classCallCheck(this, PhoneNumberSection);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showTooltip: false }, _this.


    tooltipHandler = function () {
      _this.setState({ showTooltip: !_this.state.showTooltip });
    }, _this.

    calculateIndentSize = function () {var _this$props =
      _this.props,initialPhoneValue = _this$props.initialPhoneValue,isMobile = _this$props.isMobile,locale = _this$props.locale;
      return 'calc(' + Math.round(initialPhoneValue.length / 2) + 'em + ' + lockIndent(isMobile, locale) + 'px)';
    }, _this.

    handleSelectFlag = function (value, flag) {return (
        _this.props.onPhoneChange(null, value || _this.props.initialPhoneValue, flag));}, _this.

    renderSubmitButton = function () {return !_this.props.phoneIsVerified &&
      _react2.default.createElement('div', { key: 'submitButton', className: styles.submitButton },
        _react2.default.createElement('div', { className: styles.tooltipButtonWrapper },
          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: _this.props.locale,
              fetchToken: _this.props.fetchReCaptchaToken,
              doReset: _this.props.doResetCaptcha },

            _react2.default.createElement('button', null,
              _this.props.translate('verifyPhone'))),



          _react2.default.createElement('div', { className: styles.tooltipButton },
            _react2.default.createElement('img', {
              src: _helpButton2.default,
              alt: 'help-icon',
              tabIndex: 0,
              onClick: _this.tooltipHandler,
              onBlur: function onBlur() {return _this.setState({ showTooltip: false });} }),

            _this.state.showTooltip ?
            _react2.default.createElement(_components.OMTooltip, {
              msg: _this.props.tooltipMsg,
              locale: _this.props.locale,
              className: 'phoneVerificationTooltip',
              onClose: _this.tooltipHandler }) :
            null)),



        _this.props.showErrorMessage ?
        _react2.default.createElement('div', { className: styles.invalidMessage },
          _this.props.errorMessage,
          _this.props.phoneNumberAlreadyTaken &&
          _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '/contact') }, '\xA0',

            _this.props.translate('contactUs'))) :



        null);}, _this.



    renderNotReceiveSmsMessage = function () {return !_this.props.phoneIsVerified &&
      _react2.default.createElement('div', { key: 'notReceiveMessage', className: styles.notReceiveMessage },
        _this.props.translate('notReceiveSms'),
        _react2.default.createElement(_components.GoogleReCaptcha, {
            locale: _this.props.locale,
            fetchToken: _this.props.fetchReCaptchaToken,
            doReset: _this.props.doResetCaptcha },

          _react2.default.createElement('span', { className: styles.sendAgain }, '\xA0',
            _this.props.translate('sendAgain'))));}, _this.





    renderVerifiedLabel = function () {return _this.props.phoneIsVerified &&
      _react2.default.createElement('div', { className: styles.verified },
        _react2.default.createElement('span', { className: 'icon icon-check' }), '\xA0',
        _this.props.translate('verified'));}, _temp), _possibleConstructorReturn(_this, _ret);}PhoneNumberSection.prototype.



  render = function render() {var _cx, _ref;var _props =
    this.props,phoneIsVerified = _props.phoneIsVerified,initialPhoneValue = _props.initialPhoneValue,isMobile = _props.isMobile,isRtl = _props.isRtl;
    var indent = 'margin' + (isRtl ? 'Right' : 'Left');
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.phoneSection, (_cx = {}, _cx[styles.verifiedNumber] = phoneIsVerified, _cx)) },
        _react2.default.createElement('div', { className: styles.phoneInputWrapper },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            containerClassName: (0, _classnames2.default)('intl-tel-input', styles.countrySelect),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone',
            value: this.props.initialPhoneValue,
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: this.props.onPhoneChange,
            onSelectFlag: this.handleSelectFlag,
            useMobileFullscreenDropdown: false,
            disabled: phoneIsVerified,
            validate: this.props.validatePhoneNumber,
            nationalMode: false,
            separateDialCode: true }),

          phoneIsVerified && initialPhoneValue &&
          _react2.default.createElement('i', { style: (_ref = {}, _ref[indent] = this.calculateIndentSize(), _ref), className: 'icon-lock' }),

          this.renderVerifiedLabel()),


        _react2.default.createElement(_reactAddonsCssTransitionGroup2.default, {
            transitionName: 'code-section',
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 400 },

          this.props.phoneNumberSent ?
          this.renderNotReceiveSmsMessage() :
          this.renderSubmitButton())));



  };return PhoneNumberSection;}(_react.Component);exports.default = PhoneNumberSection;


PhoneNumberSection.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  validatePhoneNumber: _propTypes2.default.func,
  sendPhoneNumber: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  phoneNumberIsInvalid: _propTypes2.default.bool,
  phoneNumberSent: _propTypes2.default.bool,
  phoneNumberAlreadyTaken: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  showErrorMessage: _propTypes2.default.bool,
  doResetCaptcha: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  tooltipMsg: _propTypes2.default.string,
  initialPhoneValue: _propTypes2.default.string,
  phoneIsVerified: _propTypes2.default.bool,
  onPhoneChange: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneVerificationMyAccount/Sections/PhoneNumberSection.js
// module id = 2775
// module chunks = 0